import { render, staticRenderFns } from "./NewsDetail1.vue?vue&type=template&id=708f9a4a&scoped=true"
var script = {}
import style0 from "./NewsDetail1.vue?vue&type=style&index=0&id=708f9a4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708f9a4a",
  null
  
)

export default component.exports